import { Controller } from "@hotwired/stimulus";

// Up/Down arrows navigate through the visible card list. No wrap at the ends.
// Disabled when focus is inside an input/textarea/select/contenteditable so
// the responder can still use arrows to move within the response field.
//
// Mounted on the same element as `next-unanswered-controller` (which owns the
// `n` shortcut) so they can share the `list` target.
export default class extends Controller {
  static targets = ["list"];

  connect() {
    this.boundKeydown = (e) => this.handleKeydown(e);
    document.addEventListener("keydown", this.boundKeydown);
  }

  disconnect() {
    document.removeEventListener("keydown", this.boundKeydown);
  }

  handleKeydown(event) {
    if (event.key !== "ArrowUp" && event.key !== "ArrowDown") return;
    if (this.shouldIgnore(event)) return;
    if (!this.hasListTarget) return;

    const cards = Array.from(this.listTarget.querySelectorAll(".jq-v2-question-card"));
    if (cards.length === 0) return;

    const selectedIndex = cards.findIndex((c) => c.classList.contains("is-selected"));
    let target;
    if (event.key === "ArrowDown") {
      target = selectedIndex < 0 ? cards[0] : cards[Math.min(selectedIndex + 1, cards.length - 1)];
    } else {
      target = selectedIndex < 0 ? cards[0] : cards[Math.max(selectedIndex - 1, 0)];
    }

    const link = target?.querySelector("a.jq-v2-card-link");
    if (!link) return;

    event.preventDefault();
    link.click();
    target.scrollIntoView({ block: "nearest", behavior: "smooth" });
  }

  shouldIgnore(event) {
    const tag = (event.target.tagName || "").toLowerCase();
    if (tag === "input" || tag === "textarea" || tag === "select") return true;
    if (event.target.isContentEditable) return true;
    if (event.metaKey || event.ctrlKey || event.altKey) return true;
    return false;
  }
}
